import { createEnum } from './enum-kit.js';
import { enumLabelMap, enumValues } from './utils.js';
export const purchaseRequirementStatusEnum = createEnum({
    DRAFT: ['draft', '草稿', 'default'],
    REVIEWING: ['reviewing', '审核中', 'processing'],
    APPROVED: ['approved', '审核通过', 'success'],
    REJECTED: ['rejected', '审核拒绝', 'error'],
});
export const PURCHASE_REQUIREMENT_STATUSES = enumValues(purchaseRequirementStatusEnum);
export const PURCHASE_REQUIREMENT_STATUS_LABEL_MAP = enumLabelMap(purchaseRequirementStatusEnum);
//# sourceMappingURL=purchase-requirement.js.map